export default __webpack_public_path__ + "static/zLogoEvistamp-3a78e52133738c16e705683fc2fbe3a0.png";